import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Explore from "./Explore";
import Retail from "./Retail";
import CaseStudy from "./CaseStudy";
import K12 from "./k12";
import Element from "./Element";
import Healthcare from "./Healthcare";
import Navigation from "./Navigation";
import HigherEd from "./HigherEd";
import PeriodicTable from "./PeriodicTable";
import logo from "./img/Extreme-Elements_RGB.svg";
import tableIcon from "./img/elements.svg";
import chem from "./img/chem.png";
import DelayLink from "./DelayLink";
import SelectVertical from "./SelectVertical";
import Export from "./Export";
import "./App.scss";
import "./css/animate.css";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logoState: "bounceInUp",
      elementAnimation: "zoomInDown",
      buttonState: "flipInX delay-1s",
      startExplore: true,
      moveElement: "unmoved",
      viewTable: false,
      viewPS: false,
      pathChosen: false
    };
  }

  startExplore() {
    this.setState({ logoState: "bounceOutDown", buttonState: "bounceOutDown" });

    this.setState({ viewTable: true, startExplore: false });
  }

  moveElement() {
    this.setState({ moveElement: "moved" });
  }
  exploreElements() {
    this.setState({
      viewTable: true,
      pathChosen: true
    });
  }
  render() {
    return (
      <Router>
        <div className="App">
          <Navigation />
          <Route exact path="/" component={Explore} />
          <Route path="/table" component={PeriodicTable} />
          <Route path="/element" component={Element} />
          <Route path="/healthcare" component={Healthcare} />
          <Route path="/retail" component={Retail} />
          <Route path="/k12" component={K12} />
          <Route path="/highereducation" component={HigherEd} />
          <Route path="/case" component={CaseStudy} />
          <Route path="/export" component={Export} />
          {this.state.viewTable === true ? <PeriodicTable /> : ""}
        </div>
      </Router>
    );
  }
}

export default App;
